import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { Season } from "./seasons.service";
import { TypeManagerDecorator } from "../../../main/type.map.service";

@TypeManagerDecorator("s25-ng-season")
@Component({
    selector: "s25-ng-season",
    template: `
        @if (init) {
            @if (season.seasonId) {
                <div>Season Id: {{ season.seasonId }}</div>
            }
            <div class="c-margin-top--single">
                <label>
                    Season Code
                    <input class="c-input" type="text" [(ngModel)]="season.code" />
                </label>
            </div>
            <div class="c-margin-top--single">
                <label>
                    Housing Start Date
                    <s25-datepicker [(value)]="season.housingStartDate" />
                </label>
            </div>
            <div class="c-margin-top--single">
                <label>
                    Housing End Date
                    <s25-datepicker [(value)]="season.housingEndDate" />
                </label>
            </div>
            <!--            <div class="c-margin-top&#45;&#45;single">-->
            <!--                <label>-->
            <!--                    Match Season Open Date-->
            <!--                    <s25-datepicker [(value)]="season.matchOpenDate"/>-->
            <!--                </label>-->
            <!--            </div>-->
            <!--            <div class="c-margin-top&#45;&#45;single">-->
            <!--                <label>-->
            <!--                    Match Season Close Date-->
            <!--                    <s25-datepicker [(value)]="season.matchCloseDate"/>-->
            <!--                </label>-->
            <!--            </div>-->
            <div class="c-margin-top--single">
                <label>
                    Description
                    <textarea class="cn-form__control" [(ngModel)]="season.descr"></textarea>
                </label>
            </div>
            <div class="c-margin-top--single">
                <label>
                    Building Message
                    <textarea class="cn-form__control" [(ngModel)]="season.buildingMsg"></textarea>
                </label>
            </div>
        }
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class SeasonComponent implements OnInit {
    @Input() season: Season;
    init = false;

    constructor(private cd: ChangeDetectorRef) {}

    ngOnInit() {
        this.init = true;
        this.cd.detectChanges();
    }
}
